// 引用axios
import Constants from '../components/Constants'
import axios from 'axios'
import router from '../router/router'

var defaultTimeout = 5000; //上线需要改为5000

function doHttpRequest(this_, method, url, params, callback, config) {
  if (!callback) {
    throw TypeError('回调函数不能为空')
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' || method === 'DELETE'? params : null,
    params: method === 'GET'? params : null,
    baseURL: Constants.BASE_URL,
    withCredentials: false
    , timeout: (config && config.timeout) > 0 ? config.timeout : defaultTimeout
    , showLoading: (config && config.loading === false) ? false : true
  }).then(function (res) {
    let rsp = res.data;
    if (rsp.code!=200 && rsp.message == '1001') {
      this_.$msgError('会话已过期，请重新登陆！', function () {
        sessionStorage.clear();
        router.replace({path: "/login"});
      });

    } else {
      callback(rsp);
    }
  }).catch(function (err) {
    console.log(err);
    if (err.toString().indexOf("ReferenceError") != -1) {
      this_.$msgError('引用错误！');
    } else if (err.toString().indexOf("SyntaxError") != -1) {
      this_.$msgError('语法错误！');
    } else {
      if (err.toString().indexOf("timeout") != -1) {
        this_.$msgError('请求超时，请重试！');
      } else if (err.toString().indexOf("TypeError") != -1) {
        this_.$msgError('类型错误，请检查代码语法！');
      } else {
        this_.$msgError('服务器开小差了，请重试！');
      }
    }
  })
}

// 返回在vue模板中的调用接口
export default {
  install(Vue, options) {

    Vue.prototype.$get = function (url, callback, config) {
      return doHttpRequest(this, 'GET', url, null, callback, config)
    };
    Vue.prototype.$post = function (url, params, callback, config) {
      return doHttpRequest(this, 'POST', url, params, callback, config)
    };
    Vue.prototype.$put = function (url, params, callback, config) {
      return doHttpRequest(this, 'PUT', url, params, callback, config)
    };
    Vue.prototype.$delete = function (url, params,callback, config) {
      return doHttpRequest(this, 'DELETE', url,params,callback, config)
    }
  }
  , method: {}
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js